var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    _vm._l(_vm.sortedScenarios, function(scenario) {
      return _c(
        "div",
        { key: scenario.Id, staticClass: "col-3 form-group" },
        [_vm._t("default", null, { scenario: scenario })],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }